// watermarkPdf.js
import { PDFDocument, rgb, StandardFonts, degrees } from 'pdf-lib';

export async function WatermarkPdf(file, watermarkText) {
  const arrayBuffer = await file.arrayBuffer();
  const pdfDoc = await PDFDocument.load(arrayBuffer);
  const pages = pdfDoc.getPages();
  const font = await pdfDoc.embedFont(StandardFonts.Helvetica);

  for (const page of pages) {
    try {
      // draw a subtle border on the page
      const { width, height } = page.getSize();
      const borderMargin = 10;
      page.drawRectangle({
        x: borderMargin / 2,
        y: borderMargin / 2,
        width: width - borderMargin,
        height: height - borderMargin,
        borderColor: rgb(0.2, 0.2, 0.2),
        borderWidth: 0.5,
      });
    } catch (e) {
      // ignore if draw operations not supported
    }
    const { width, height } = page.getSize();
    page.drawText(watermarkText, {
      x: width / 2 - 100,
      y: height / 2,
      size: 50,
      font,
      color: rgb(0.75, 0.75, 0.75),
  rotate: degrees(45),
      opacity: 0.3,
    });
  }

  const pdfBytes = await pdfDoc.save();
  const blob = new Blob([pdfBytes], { type: 'application/pdf' });
  return URL.createObjectURL(blob);
}
// src/components/watermarkPdf.js